export default "__VITE_ASSET__57995d97__"